export const handleTagertMetrics={
        "dimensions": [
          "Target.pod_fk",
          "Target.isr_id",
          "Target.isr_name",
          "Target.isr_target",
          "Target.fsr_id",
          "Target.fsr_name",
          "Target.fsr_target",
          "Target.pincodes",
          "Target.target_inactive_to_isr",
          "Target.target_inactive_to_fsr",
          "Target.isr_target_for_fsr",
          "Target.fsr_target_for_isr",
           "Target.pod_name",
           "Target.client_ids"
        ],
        "order": {
          "Target.pod_fk": "asc"
        }
      }
  


  const myContributionCase = {
    "measures": [
        "Contribution.total_case_count",
        "Contribution.incentive_amount"
    ],
   
    "order": {
        "Contribution.Date": "asc"
    },
    "dimensions": [
        // "Contribution.pincode",
        "Contribution.agent_name",
        "Contribution.client_fk",
        "Contribution.Date",
        // "Contribution.day_name",
        "Contribution.modality",
      
        // "Contribution.agent_name",
        // "Contribution.modality",
        // "Contribution.case_id",
        //   "Contribution.agent_name"
    ],

}

  

 
export const handleQueryMyCaseCount = (
    name, startDate, endDate, modality,last11month
) => {

    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "afterDate",
            "values": [
                startDate
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",
            "values": [
                last11month
            ]
        }
    )
    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "beforeDate",
            "values": [
                endDate
            ]
        }
    )



     if(name!=='All'){
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [name],
        });
    }

    if (modality?.length > 0 && modality?.length <= 3) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }


    if (filters?.length) {
        return { ...myContributionCase, filters };
    }
    return myContributionCase;

};


const QueryClientView = {
      "order": {
    "Contribution.total_case_count": "desc",

  },
  "measures": [
    "Contribution.total_case_count",
     "Contribution.incentive_amount"
  ],
  "dimensions": [
    "Contribution.pincode",
    "Contribution.client_name",
    "Contribution.client_fk",
    "Contribution.modality",
    "Contribution.final_discount"
  ]
}

export const handleQueryClientView = ( name, startDate, endDate, modality,last11month) => {
    let filters = [];
    let tableName = "Contribution";

    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "afterDate",    
            "values": [
                startDate
            ]
        }
    )
    
    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "beforeDate",    
            "values": [
                endDate
            ]
        }
    )

    filters.push(
        {
            "member": "Contribution.Onboarded_date",
            "operator": "afterDate",    
            "values": [
                last11month 
            ]
        }
    )

    if(name!=='All'){
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [name],
        });
    }

    if (modality?.length > 0 && modality?.length <= 3) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }

    if (filters?.length) {
        return { ...QueryClientView, filters };
    }
    return QueryClientView;
}


const QueryClientViewDay = {
    "order": {
  "Contribution.total_case_count": "desc"
},
"measures": [
  "Contribution.total_case_count",
  "Contribution.incentive_amount"
],
"dimensions": [
  "Contribution.pincode",
  "Contribution.client_name",
  "Contribution.client_fk",
  "Contribution.modality",
  "Contribution.final_discount"
//   "Contribution.Date"
]
}

export const handleQueryClientViewDay = ( name, date, modality,last11month,pincode,others) => {
    let filters = [];
    let tableName = "Contribution";
    console.log(modality, 'modality')
    filters.push(
        {
            "member": "Contribution.Date",
            "operator": "equals",
            "values": [
                date
            ]
        }
    )

    filters.push({
        "member": "Contribution.Onboarded_date",
        "operator": "afterDate",
        "values": [
            last11month
        ]
    })

    if(name!=='All'){
        filters.push({
            member: tableName + ".agent_name",
            operator: "contains",
            values: [name],
        });
    }

    if (modality?.length > 0 && modality?.length <= 4) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }

    if(pincode){
        filters.push({
            member: tableName + ".client_fk",
            operator: "equals",
            values: pincode?.split(',').map(p => p.trim()),
        });
    }

    // if(others?.length>0){
    //     filters.push({
    //         member: tableName + ".pincode",
    //         operator: "notContains",
    //         values: others,
    //     });
    // }

    if (filters?.length) {
        return { ...QueryClientViewDay, filters };
    }
    return QueryClientViewDay;
}


const clientViewCalendar = {
    "dimensions": [
      "Contribution.Date",
      "Contribution.modality",
      "Contribution.final_discount"
    ],
    "order": {
      "Contribution.Date": "asc"
    },
    "measures": [
      "Contribution.total_case_count",
      "Contribution.incentive_amount"
    ],
  
  }



export const handleQueryClientViewCalendar = (clientId, startDate, endDate, modality) => {
    let filters = [];
    let tableName = "Contribution";

    filters.push({
        member: tableName + ".client_fk",
        operator: "equals",
        values: [clientId],
    });

    filters.push({
        "member": "Contribution.Date",
        "operator": "afterDate",
        "values": [
            startDate
        ]
    })

    filters.push({
        "member": "Contribution.Date",
        "operator": "beforeDate",
        "values": [endDate]
    })

    if (modality?.length > 0 && modality?.length <= 4) {
        filters.push({
            member: tableName + ".modality",
            operator: "equals",
            values: modality,
        });
    }
    if (filters?.length) {
        return { ...clientViewCalendar, filters };
    }
    return clientViewCalendar;
}



export const processModalityData = (data) => {
    return {
        client_id: data?.['Contribution.client_fk'],
        client_name: data?.['Contribution.client_name'],
        pincode: data?.['Contribution.pincode'],
        modalities: {
            XRAY: {
                total: parseInt(data?.['XRAY,0%,Contribution.total_case_count'] || 0) + parseInt(data?.['XRAY,below 50%,Contribution.total_case_count'] || 0) + parseInt(data?.['XRAY,beyond 50%,Contribution.incentive_amount'] || 0),
                amount: parseInt(data?.['XRAY,0%,Contribution.incentive_amount'] || 0) + parseInt(data?.['XRAY,below 50%,Contribution.incentive_amount'] || 0) + parseInt(data?.['XRAY,beyond 50%,Contribution.incentive_amount'] || 0),
                splits: {
                    '0%': parseInt(data?.['XRAY,0%,Contribution.total_case_count'] || 0),
                    'below 50%': parseInt(data?.['XRAY,below 50%,Contribution.total_case_count'] || 0),
                    'beyond 50%': parseInt(data?.['XRAY,beyond 50%,Contribution.total_case_count'] || 0),
                    'incentive_amount': {
                        '0%': parseInt(data?.['XRAY,0%,Contribution.incentive_amount'] || 0),
                        'below 50%': parseInt(data?.['XRAY,below 50%,Contribution.incentive_amount'] || 0),
                        'beyond 50%': parseInt(data?.['XRAY,beyond 50%,Contribution.incentive_amount'] || 0),
                    }
                }
            },
            CT: {
                total: parseInt(data?.['CT,0%,Contribution.total_case_count'] || 0) + parseInt(data?.['CT,below 20%,Contribution.total_case_count'] || 0) + parseInt(data?.['CT,below 40%,Contribution.total_case_count'] || 0) + parseInt(data?.['CT,beyond 40%,Contribution.total_case_count'] || 0),
                amount: parseInt(data?.['CT,0%,Contribution.incentive_amount'] || 0) + parseInt(data?.['CT,below 20%,Contribution.incentive_amount'] || 0) + parseInt(data?.['CT,below 40%,Contribution.incentive_amount'] || 0) + parseInt(data?.['CT,beyond 40%,Contribution.incentive_amount'] || 0),
                splits: {
                    '0%': parseInt(data?.['CT,0%,Contribution.total_case_count'] || 0),
                    'below 20%': parseInt(data?.['CT,below 20%,Contribution.total_case_count'] || 0),
                    'below 40%': parseInt(data?.['CT,below 40%,Contribution.total_case_count'] || 0),
                    'beyond 40%': parseInt(data?.['CT,beyond 40%,Contribution.total_case_count'] || 0),
                    'incentive_amount': {
                        '0%': parseInt(data?.['CT,0%,Contribution.incentive_amount'] || 0),
                        'below 20%': parseInt(data?.['CT,below 20%,Contribution.incentive_amount'] || 0),
                        'below 40%': parseInt(data?.['CT,below 40%,Contribution.incentive_amount'] || 0),
                        'beyond 40%': parseInt(data?.['CT,beyond 40%,Contribution.incentive_amount'] || 0),
                    }
                }
            },
            MRI: {
                total: parseInt(data?.['MRI,0%,Contribution.total_case_count'] || 0) + parseInt(data?.['MRI,below 20%,Contribution.total_case_count'] || 0) + parseInt(data?.['MRI,below 40%,Contribution.total_case_count'] || 0) + parseInt(data?.['MRI,beyond 40%,Contribution.total_case_count'] || 0),
                amount: parseInt(data?.['MRI,0%,Contribution.incentive_amount'] || 0) + parseInt(data?.['MRI,below 20%,Contribution.incentive_amount'] || 0) + parseInt(data?.['MRI,below 40%,Contribution.incentive_amount'] || 0) + parseInt(data?.['MRI,beyond 40%,Contribution.incentive_amount'] || 0),
                splits: {
                    '0%': parseInt(data?.['MRI,0%,Contribution.total_case_count'] || 0),
                    'below 20%': parseInt(data?.['MRI,below 20%,Contribution.total_case_count'] || 0),
                    'below 40%': parseInt(data?.['MRI,below 40%,Contribution.total_case_count'] || 0),
                    'beyond 40%': parseInt(data?.['MRI,beyond 40%,Contribution.total_case_count'] || 0),
                    'incentive_amount': {
                        '0%': parseInt(data?.['MRI,0%,Contribution.incentive_amount'] || 0),
                        'below 20%': parseInt(data?.['MRI,below 20%,Contribution.incentive_amount'] || 0),
                        'below 40%': parseInt(data?.['MRI,below 40%,Contribution.incentive_amount'] || 0),
                        'beyond 40%': parseInt(data?.['MRI,beyond 40%,Contribution.incentive_amount'] || 0),
                    }
                }
            },
            NM: {
                total: parseInt(data?.['NM,0%,Contribution.total_case_count'] || 0) + parseInt(data?.['NM,below 20%,Contribution.total_case_count'] || 0) + parseInt(data?.['NM,below 40%,Contribution.total_case_count'] || 0) + parseInt(data?.['NM,beyond 40%,Contribution.total_case_count'] || 0),
                amount: parseInt(data?.['NM,0%,Contribution.incentive_amount'] || 0) + parseInt(data?.['NM,below 20%,Contribution.incentive_amount'] || 0) + parseInt(data?.['NM,below 40%,Contribution.incentive_amount'] || 0) + parseInt(data?.['NM,beyond 40%,Contribution.incentive_amount'] || 0),
                splits: {
                    '0%': parseInt(data?.['NM,0%,Contribution.total_case_count'] || 0),
                    'below 20%': parseInt(data?.['NM,below 20%,Contribution.total_case_count'] || 0),
                    'below 40%': parseInt(data?.['NM,below 40%,Contribution.total_case_count'] || 0),
                    'beyond 40%': parseInt(data?.['NM,beyond 40%,Contribution.total_case_count'] || 0),
                    'incentive_amount': {
                        '0%': parseInt(data?.['NM,0%,Contribution.incentive_amount'] || 0),
                        'below 20%': parseInt(data?.['NM,below 20%,Contribution.incentive_amount'] || 0),
                        'below 40%': parseInt(data?.['NM,below 40%,Contribution.incentive_amount'] || 0),
                        'beyond 40%': parseInt(data?.['NM,beyond 40%,Contribution.incentive_amount'] || 0),
                    }
                }
            }
        },
    };
};